export const DEFAULT_TITLE = "magnita.ai";
export const UNSEEN_NOTIFICATION_COUNT_LIMIT = 99;
